'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _withDevice = require('./with-device');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withDevice).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }